import { Component, Inject, inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormTranslator } from 'app/common/services/translation.service';
import { SectorListDto, ThematicUpdateDto } from 'app/common/generated';

@Component({
    selector: 'app-thematics-update',
    imports: [ReactiveFormsModule, TranslocoModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, MatSelectModule, MatTooltipModule],
    templateUrl: './thematic-update.component.html'
})
export class ThematicUpdateComponent implements OnInit {

    private dialogRef = inject(MatDialogRef<ThematicUpdateComponent>);
    trans: FormTranslator;

    constructor(@Inject(MAT_DIALOG_DATA) public data: { thematic: ThematicUpdateDto }) {
        this.trans = new FormTranslator(this.thematicForm);
    }

    sectors: SectorListDto[] = [];
    loadingSectors = true;

    thematicForm = new UntypedFormGroup({
        id: new FormControl<string | null>(null, [Validators.required]),
        nameFr: new FormControl<string | null>(null, [Validators.required]),
        nameEn: new FormControl<string | null>(null, [Validators.required]),
        descriptionFr: new FormControl<string | null>(null),
        descriptionEn: new FormControl<string | null>(null)
    });

    ngOnInit() {
        this.thematicForm.patchValue(this.data.thematic);
        this.loadingSectors = false;
    }

    onSubmit() {
        if (this.thematicForm.valid) {
            const formData = this.thematicForm.value;
            this.dialogRef.close(formData);

        } else {
            console.warn('Form is invalid');
        }
    }

    onCancel() {
        this.dialogRef.close(false);
    }
}